export const GET_CHECK_TIME_REQUEST = 'checkTimeReducer/GET_CHECK_TIME_REQUEST';
export const GET_CHECK_TIME_SUCCESS = 'checkTimeReducer/GET_CHECK_TIME_SUCCESS';
export const GET_CHECK_TIME_FAILED = 'checkTimeReducer/GET_CHECK_TIME_FAILED';
